import { render, staticRenderFns } from "./indic-tab.vue?vue&type=template&id=206754a5&"
import script from "./indic-tab.vue?vue&type=script&lang=ts&"
export * from "./indic-tab.vue?vue&type=script&lang=ts&"
import style0 from "./indic-tab.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports